import styled from '@emotion/styled'
import { colors, spacing, radius, font } from '@mobi/component-library/Foundations'

export const Content = styled.div({
  backgroundColor: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.sm,
})

export const Footer = styled.div({
  flex: '0 0 100px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'top',
  gap: spacing.sm,
  marginTop: spacing.smx2,
})

export const DepositLimitFormStyled = styled.div({
  display: 'grid',
  rowGap: spacing.sm,
})

export const DepositLimitLegal = styled.div({
  borderRadius: radius.lgx2,
  backgroundColor: colors.neutral[100],
  padding: spacing.sm,
  color: colors.neutral[900],
  marginTop: spacing.md,
  ...font.size.md,
})
